import { Textarea, TextareaProps } from '@chakra-ui/react';
import { FieldPath, UseFormReturn } from 'react-hook-form';

type Props<TFieldValues> = TextareaProps & {
  name: FieldPath<TFieldValues>;
  register: UseFormReturn<TFieldValues>['register'];
};

export const DescriptionTextarea = <TFieldValues,>({
  name,
  register,
  ...textareaProps
}: Props<TFieldValues>) => (
  <Textarea
    type="text"
    {...register(name, {
      required: '必須項目です。',
      maxLength: {
        value: 255,
        message: '説明は255文字以内にする必要があります。',
      },
    })}
    {...textareaProps}
  />
);
